import * as React from 'react';
export class StackContainerRenderer extends React.PureComponent {
    render() {
        return React.createElement("div", { style: {
                display: 'grid',
                gridTemplateRows: 'max-content 1fr'
            } }, this.props.children);
    }
}
//# sourceMappingURL=stack-container-renderer.js.map